module.exports = __webpack_public_path__ + "img/ad.c7c7a227.png";